import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, Tooltip } from 'antd';
import BadgeIcon from '../BadgeIcon';
const TagForeign = ({ tag, onModalOpen, onTagDelete, tooltipTitle, children, }) => {
    return (_jsx(Tooltip, { title: tooltipTitle, children: _jsx(Badge, { count: (_jsx(BadgeIcon, { tag: tag, onModalOpen: onModalOpen, onTagDelete: onTagDelete })), offset: [-15, 0], children: children }) }));
};
export default TagForeign;
